import type { OwaDate } from '../../../schema';
import { GlobalCalendarLocale } from '../../../intl/globalCalendarLocale';
import { RokuyouDay } from '../../../intl/RokuyouDay';
import getRokuyouDay from './getRokuyouDay';
import { assertNever } from 'owa-assert';

export default function getIntlDateRokuyou(date: OwaDate, locale: GlobalCalendarLocale): string {
    // A bit of confusion since it's called a "day" but it's used here as a date
    const rokuyouDay = getRokuyouDay(date);

    // If we don't have a Rokuyou day  or this isn't a selected Rokuyou
    // day then return an empty string
    if (!rokuyouDay || !locale.rokuyouDays.has(rokuyouDay)) {
        return '';
    }

    // These are non-localized strings
    switch (rokuyouDay) {
        case RokuyouDay.Senshou:
            return '先勝';
        case RokuyouDay.Tomobiki:
            return '友引';
        case RokuyouDay.Sakimake:
            return '先負';
        case RokuyouDay.Butsumetsu:
            return '仏滅';
        case RokuyouDay.Taian:
            return '大安';
        case RokuyouDay.Shakku:
            return '赤口';
        default:
            assertNever(rokuyouDay);
    }
}
